module.exports = __webpack_public_path__ + "img/IconProfile.59d6f2f0.png";